import React, { useState, useMemo, useEffect, useRef } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Certificates from "./components/Certificates";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import AppleContact from "./components/AppleContact";
import RofuelPrivacy from "./components/RofuelPrivacy";

function MainContent() {
  let currentPage = -1;
  const refHome = useRef(null);
  const refContact = useRef(null);
  const refCertificates = useRef(null);
  const refAbout = useRef(null);

  if (useIsInViewport(refHome)) {
    currentPage = 1;
  }
  if (useIsInViewport(refAbout)) {
    currentPage = 2;
  }
  if (useIsInViewport(refCertificates)) {
    currentPage = 3;
  }
  if (useIsInViewport(refContact)) {
    currentPage = 4;
  }

  function scrollToHome() {
    refHome.current.scrollIntoView({ behavior: "smooth" });
  }
  function scrollToAbout() {
    refAbout.current.scrollIntoView({ behavior: "smooth" });
  }
  function scrollToCertificates() {
    refCertificates.current.scrollIntoView({ behavior: "smooth" });
  }
  function scrollToContact() {
    refContact.current.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className="h-screen bg-gradient-to-br from-gray-900 via-[#121212] to-black text-white">
      <Navbar
        currentPage={currentPage}
        scrollHome={scrollToHome}
        scrollAbout={scrollToAbout}
        scrollCertificates={scrollToCertificates}
        scrollContact={scrollToContact}
      />
      <div className="fixed bottom-0 w-full h-[calc(100vh-4rem)] snap-y snap-mandatory scroll-smooth overflow-y-scroll">
        <Home handleClick={scrollToAbout} ref={refHome} />
        <About ref={refAbout} />
        <Certificates ref={refCertificates} />
        <Contact ref={refContact} />
      </div>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainContent />} />
      <Route path="/apple-developer" element={<AppleContact />} />
      <Route path="/rofuel-privacy" element={<RofuelPrivacy />} />
    </Routes>
  );
}

function useIsInViewport(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIsIntersecting(entry.isIntersecting)
      ),
    []
  );

  useEffect(() => {
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}

export default App;
